var $ = jQuery;

$('.mcl-announcement-container').find('.mcl-announcement-description:not(.expired)').click(function () {

    //Expand or collapse this panel
    $(this).next().slideToggle('slow');

    $(this).find('.arrow').toggleClass('active');

    //Hide the other panels
    $(".accordion-content").not($(this).next()).slideUp('slow');

});


// WEBPACK FOOTER //
// ./src/components/organisms/announcement/announcement.js